export var FairValueGapDirection;
(function (FairValueGapDirection) {
    FairValueGapDirection["bullish"] = "bullish";
    FairValueGapDirection["bearish"] = "bearish";
})(FairValueGapDirection || (FairValueGapDirection = {}));
export var FairValueGapZoneStatus;
(function (FairValueGapZoneStatus) {
    FairValueGapZoneStatus["active"] = "active";
    FairValueGapZoneStatus["filled"] = "filled";
    FairValueGapZoneStatus["invalidated"] = "invalidated";
    FairValueGapZoneStatus["inversionSupport"] = "inversionSupport";
    FairValueGapZoneStatus["inversionResistance"] = "inversionResistance";
})(FairValueGapZoneStatus || (FairValueGapZoneStatus = {}));
export var FairValueGapFillState;
(function (FairValueGapFillState) {
    FairValueGapFillState["untouched"] = "untouched";
    FairValueGapFillState["partial"] = "partial";
    FairValueGapFillState["midpointTouched"] = "midpointTouched";
    FairValueGapFillState["filled"] = "filled";
})(FairValueGapFillState || (FairValueGapFillState = {}));
export var FairValueGapEventType;
(function (FairValueGapEventType) {
    FairValueGapEventType["bullishCreated"] = "bullishCreated";
    FairValueGapEventType["bearishCreated"] = "bearishCreated";
    FairValueGapEventType["bullishFirstTouch"] = "bullishFirstTouch";
    FairValueGapEventType["bearishFirstTouch"] = "bearishFirstTouch";
    FairValueGapEventType["bullishMidpointTouched"] = "bullishMidpointTouched";
    FairValueGapEventType["bearishMidpointTouched"] = "bearishMidpointTouched";
    FairValueGapEventType["bullishFilled"] = "bullishFilled";
    FairValueGapEventType["bearishFilled"] = "bearishFilled";
    FairValueGapEventType["bullishInvalidated"] = "bullishInvalidated";
    FairValueGapEventType["bearishInvalidated"] = "bearishInvalidated";
    FairValueGapEventType["becameInversionSupport"] = "becameInversionSupport";
    FairValueGapEventType["becameInversionResistance"] = "becameInversionResistance";
})(FairValueGapEventType || (FairValueGapEventType = {}));
//# sourceMappingURL=FairValueGapAnalyzerTypes.js.map